import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { EventRuleFormData } from '@/features/event-rules/schemas/create-event-rules.schema.ts';

export const usePostEventRuleMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (eventRule: EventRuleFormData) => {
      return toast.promise(client.post(`/events/rules`, eventRule), {
        loading: 'Creating event rule...',
        success: 'Successfully created the event rule.',
        error: (_: unknown) => `Uh oh, there was an error with creating the event rule.`,
      });
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['event-rules'] });
    },
  });
};
